module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-1-af1261001f5650ae6619c6ddd7550adb.gif";